/**
 * The code an account is known by, for showing to a person — or nothing.
 *
 * A company on a Google Sheet keys each account by its own customer code
 * ("NW-1040"), which people know and search by. A TallyPrime account is keyed
 * by the ledger's internal identifier (`tally:` and a GUID): stable, so the
 * book never mixes two ledgers up, but meaningless to read. Lists and the
 * account's header show the first and leave the second out; the identifier
 * stays on the account's TallyPrime details, for support.
 */
export function accountCode(sourceKey: string | null | undefined): string | null {
    if (!sourceKey) return null;
    return sourceKey.startsWith('tally:') ? null : sourceKey;
}

/** Whether a key is a TallyPrime ledger's identifier. */
export const isTallyKey = (sourceKey: string | null | undefined): boolean => Boolean(sourceKey?.startsWith('tally:'));
